import React from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const navigate = useNavigate();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Cluster Name',
      attr: 'name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      attr: 'branch_name',
      disableSort: true
    },
    {
      disableSort: true,
      label: 'Action',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_cluster.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_cluster.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
              <FontAwesomeIcon icon={faEye} />
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onViewClick = (id) => {
    navigate(`/clusters/${id}`)
  }

  const onEditClick = (id) => {
    navigate(`/clusters/${id}/edit`)
  }

  const onNewClick = () => {
    navigate('/clusters/new');
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_cluster.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Cluster</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  return <>
    <ListingPageComponent
      key={PAGES.ClustersListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.ClustersListingPage.name)}
      breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Cluster', url: '/clusters'}]}
      listingMutation={getApi('clusters')}
      className="clusters-listing-page"
      contentHeading="All Clusters - Results"
      headers={headers}
      recordsKey="clusters"
      searchBy={['ID']}
      tableHeaderActionsComponent={tableHeaderActionsComponent()}
    />
  </>
};

export default Index;
